import { computed } from 'vue'
import type { LanguageInfo } from '~/types/translation'
import { useTranslationStore } from '~/stores/translation'

/**
 * 语言显示名映射（无兜底逻辑）
 * - 仅基于配置中心下发的语言列表(from/to)
 * - 若未命中映射，则直接回退显示代码本身
 */
export function useLanguageDisplay() {
  const store = useTranslationStore()

  // 合并 from/to 列表，按 code 建索引
  const codeMap = computed<Record<string, LanguageInfo>>(() => {
    const m: Record<string, LanguageInfo> = {}
    for (const x of store.srcLanguageList) m[x.code] = x
    for (const x of store.dstLanguageList) m[x.code] = x
    return m
  })

  const codeToName = (code?: string | null): string => {
    if (!code) return ''
    const c = code.toLowerCase()
    return codeMap.value[c]?.name || c
  }

  // 留口：未来如需 i18n，可在此按 locale 返回对应语言名
  const codeToLocalizedName = (code?: string | null, _locale?: string): string => codeToName(code)

  return { codeToName, codeToLocalizedName }
}
